// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zg7SR","badges":"styles_badges__1w1n7"};